import axios from "axios";

export default {
    state:{
        estilodoc:[]
    },
    mutations:{
        setEstilos(state,items){
            state.estilodoc=items
        },
    },
    actions:{
        async getEstilos({commit,rootState,getters},idestablecimiento){

            try {
                const { data } = await axios.get(`${rootState.urlapi}/estilodocumento/establecimiento/${idestablecimiento}`,getters.getTokenUser);
                commit("setEstilos",data)
            } catch (error) {
                commit("setEstilos",[])
                console.error(error)
            }
        },
        changeEstilosDoc({commit},item){
            commit("setEstilos",item)
        },
        async postEstilo({commit,rootState,getters},data){
            try {
                await axios.post(`${rootState.urlapi}/estilodocumento`,data,getters.getTokenUser);
                commit("setEstilos",data)
            } catch (error) {
                commit("setEstilos",[])
                console.error(error)
            }
        },
        async patchEstilo({commit,rootState,getters},data){
            try {
                await axios.patch(`${rootState.urlapi}/estilodocumento/${data.id}`,data,getters.getTokenUser);
                commit("setEstilos",data)
            } catch (error) {
                commit("setEstilos",[])
                console.error(error)
            }
        }
    },
    getters:{
        getEstiloDoc(state){
            return state.estilodoc
        }
    }
}